<template>
    <div>
      <div class="common-header-wrap">
        <mt-header title="店铺入驻" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
        <step :options="options" :active="1"></step>

        <div v-if="storeJoinin.store_type==0">
            <div>
                <div class="label">开户银行信息</div>
                <div class="main-content">
                    <flex-line class="field-line" :show-border="true"><span class="field-name">银行开户名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.bank_account_name" /></div></flex-line>
                    <flex-line class="field-line" :show-border="true"><span class="field-name">公司银行账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.bank_account_number" /></div></flex-line>
                    <flex-line class="field-line" :show-border="true"><span class="field-name">银行支行名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.bank_name" /></div></flex-line>
                    <div @click="onRegion('bank_address')"><flex-line :is-link="true" :show-border="true"><span class="line-name">银行所在地</span><span slot="right">{{storeJoinin.bank_address}}</span></flex-line></div>
                    <flex-line :show-border="true"><span class="line-name">此账号为结算账号</span><div slot="right"><mt-switch v-model="isSame"></mt-switch></div></flex-line>
                </div>
            </div>
            <div v-if="!isSame">
                <div class="label">结算账号信息</div>
                <div class="main-content">
                    <flex-line class="field-line" :show-border="true"><span class="field-name">银行开户名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.settlement_bank_account_name" /></div></flex-line>
                    <flex-line class="field-line" :show-border="true"><span class="field-name">公司银行账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.settlement_bank_account_number" /></div></flex-line>
                    <flex-line class="field-line" :show-border="true"><span class="field-name">银行支行名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.settlement_bank_name" /></div></flex-line>
                    <div @click="onRegion('settlement_bank_address')"><flex-line :is-link="true" :show-border="true"><span class="line-name">银行所在地</span><span slot="right">{{storeJoinin.settlement_bank_address}}</span></flex-line></div>
                </div>
            </div>
        </div>
        <div v-else class="main-content">
            <flex-line class="field-line" :show-border="true"><span class="field-name">支付宝姓名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.settlement_bank_account_name" /></div></flex-line>
            <flex-line class="field-line" :show-border="true"><span class="field-name">支付宝账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="storeJoinin.settlement_bank_account_number" /></div></flex-line>
        </div>
        <div class="common-btn ds-button-large mt-10"  @click="nextStep">下一步</div>
        <div>
            <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
        </div>
    </div>
</template>
<script>

import { Toast, MessageBox } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import RegionPicker from '../../RegionPicker'
import Step from '../../Step'
import { getStoreJoinin, saveStoreJoinin3 } from '../../../api/seller'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    Step,
    RegionPicker
  },
  data () {
    return {
      isSame: false,
      regionName: '',
      options: [{ title: '公司资质' }, { title: '财务资质' }, { title: '店铺信息' }, { title: '合同签订' }]
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      storeJoinin1: state => state.member.storeJoinin1,
      storeJoinin0: state => state.member.storeJoinin0,
      storeJoininType: state => state.member.storeJoininType,
      config: state => state.config.config
    }),
    storeJoinin:function(){
      if(this.storeJoininType==1){
        return this.storeJoinin1
      }else{
        return this.storeJoinin0
      }
    },
  },
  created: function () {
    this.isSame = !!this.storeJoinin.is_settlement_account
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
        this.sellerJoininTypeSave({storeJoininType:store_joinin.store_type})
        if (store_joinin.joinin_state == 11 || store_joinin.joinin_state == 20 || store_joinin.joinin_state == 31) {
          this.$router.push({ name: 'SellerJoinin5' })
          return
        }
        if (store_joinin.joinin_state == 40) {
            Toast('您的店铺已开通')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }
        // if (!this.storeJoinin) {
          this.isSame = !!this.storeJoinin.is_settlement_account
          this.sellerJoininSave({ storeJoinin: store_joinin })
          this.fetchConfig({}).then(
            response => {
              if(this.config.store_joinin_open==2 || this.config.store_joinin_open==3){
                if(this.config.store_joinin_open==3){
                  this.storeJoinin['store_type']=1
                }
                if(this.config.store_joinin_open==2){
                  this.storeJoinin['store_type']=0
                }
                this.$forceUpdate()
              }
            },
            error => {
              Toast(error.message)
            }
          )
        // }
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig',
    }),
    ...mapMutations({
      memberPoint: 'memberPoint',
      sellerJoininSave: 'sellerJoininSave',
      sellerJoininTypeSave: 'sellerJoininTypeSave'
    }),
    nextStep () {
      this.storeJoinin.is_settlement_account = this.isSame
      saveStoreJoinin3(this.storeJoinin).then(res => {
        this.sellerJoininSave({ storeJoinin: this.storeJoinin })
        this.$router.push({ name: 'SellerJoinin4' })
      }).catch(error => {
        Toast(error.message)
      })
    },
    onPickerConfirm (values) {
      if (this.regionName == 'bank_address') {
        this.storeJoinin.bank_address = this.getRegionStr(values)
      }
      if (this.regionName == 'settlement_bank_address') {
        this.storeJoinin.settlement_bank_address = this.getRegionStr(values)
      }
      this.$forceUpdate()
    },
    onRegion (name) {
      this.regionName = name
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    }
  }
}
</script>
<style  lang="scss" scoped>
    .main-content{background: #fff;padding:0 $pageSpace}
    .container {
        background: #fff;
    }
    .label {
        padding: .5rem;
        font-size:$h2;
        background: #eee;
    }
</style>
